import { openJumpSearch } from '@opallabs/brown-dwarf'
import { Theme } from '@opallabs/gem'
import { Tooltip, Button, Icon } from '@opallabs/lapidary'
import { AnalyticsLayer } from '@opallabs/quanta'

export const TOOLTIP_CONTENT = 'Search Opal'

type GlobalSearchButtonProps = {
  theme: Theme
}

const GlobalSearchButton: React.FC<GlobalSearchButtonProps> = ({ theme }) => (
  <AnalyticsLayer name="Jump Button">
    <Tooltip content={TOOLTIP_CONTENT} legacyTheme={theme} zIndex={9999}>
      <Button
        className="global-search-tooltip"
        name="Toggle Jump"
        onClick={openJumpSearch}
        icon={
          <Icon
            ariaHidden={true}
            glyph="gem-search"
            width={24}
            height={24}
            color="#a0aeb9"
          />
        }
        variant="ghost"
        theme={theme}
        ariaLabel="Toggle Jump Search"
      />
    </Tooltip>
  </AnalyticsLayer>
)

export default GlobalSearchButton
